// ** Axios Imports
import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/websiteIcon`

// Get website icon data (single record)
export const getWebsiteIconApi = () => {
  return axiosInstance.get(serverUrl)
}

// Get website icon data by ID
export const getWebsiteIconByIdApi = (id) => {
  return axiosInstance.get(`${serverUrl}/${id}`)
}

// Add or update website icon data
export const addOrUpdateWebsiteIconApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/addWebiteIcon`, formData)
}

// Combined service for all website icon operations
const websiteIconService = {
  getWebsiteIcon: getWebsiteIconApi,
  getWebsiteIconById: getWebsiteIconByIdApi,
  addOrUpdateWebsiteIcon: addOrUpdateWebsiteIconApi
}

export default websiteIconService
